import PropTypes from 'prop-types';

export const wizardReducerPropTypes = PropTypes.exact({
  product: PropTypes.string,
  completedStep: PropTypes.number,
  currentStep: PropTypes.number,
  totalSteps: PropTypes.number,
  directionForward: PropTypes.bool,
  steps: PropTypes.arrayOf(PropTypes.object),
  riskType: PropTypes.string,
  fluxes: PropTypes.array,
  activeFlux: PropTypes.string,
  entryFlux: PropTypes.string,
  hasChangeFlux: PropTypes.bool,
  isSheet: PropTypes.bool,
  editedData: PropTypes.bool,
  stepsV2: PropTypes.object,
  currentStepV2: PropTypes.string,
  historyV2: PropTypes.arrayOf(PropTypes.string),
});
